import React from 'react';
import Link from 'react-router/lib/Link';

import * as shapes from '../shapes';
import DiscountsTable from './Table';
import * as commonShapes from '../../../../common/shapes';
import { canUserModifyDiscounts } from '../../../../common/helpers/users';

const List = ({ discounts, baseUrl, permissions, currency }) => (
  <div className="c-wrapper">
    <div className="u-max-width-710 u-margin-auto u-mv-">
      <div className="u-text-right u-mb-">
        <Link
          className="c-btn c-btn--medium"
          to={`${baseUrl}/add`}
          display-if={canUserModifyDiscounts(permissions)}
        >
          Add discount
        </Link>
      </div>
      <DiscountsTable
        baseUrl={baseUrl}
        discounts={discounts}
        currency={currency}
        canModify={canUserModifyDiscounts(permissions)}
      />
    </div>
  </div>
);

List.propTypes = {
  discounts: shapes.discounts,
  baseUrl: shapes.url,
  permissions: commonShapes.permissions.isRequired,
  currency: shapes.string,
};

List.defaultProps = {
  discounts: [],
  baseUrl: '/settings/discounts',
  currency: 'usd',
};

export default List;
